var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showContentBriefModal
    ? _c(
        "div",
        {
          staticClass: "brief-modal-overlay",
          on: {
            click: function ($event) {
              if ($event.target !== $event.currentTarget) return null
              return _vm.close.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "brief-modal",
              attrs: { role: "dialog", "aria-labelledby": "contentBriefTitle" },
            },
            [
              _c("div", { staticClass: "brief-modal-header" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex flex-col text-center sm:text-left brief-modal-heading",
                  },
                  [
                    _c("div", { staticClass: "flex items-center gap-2" }, [
                      _c(
                        "svg",
                        {
                          staticClass:
                            "lucide lucide-file-text h-4 w-4 text-emerald-700",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: { d: "M14 2v4a2 2 0 0 0 2 2h4" },
                          }),
                          _vm._v(" "),
                          _c("path", { attrs: { d: "M10 9H8" } }),
                          _vm._v(" "),
                          _c("path", { attrs: { d: "M16 13H8" } }),
                          _vm._v(" "),
                          _c("path", { attrs: { d: "M16 17H8" } }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "h2",
                        {
                          staticClass: "brief-modal-title",
                          attrs: { id: "contentBriefTitle" },
                        },
                        [_vm._v("\n            Content Brief\n          ")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "brief-modal-subtitle" }, [
                      _vm._v(
                        "\n          Auto-generated from your selected work. Edit any section, then share or hand off.\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "brief-title-row" }, [
                      _c(
                        "svg",
                        {
                          staticClass:
                            "lucide lucide-pencil h-3 w-3 text-muted-foreground",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", { attrs: { d: "m15 5 4 4" } }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.briefTitle,
                            expression: "briefTitle",
                          },
                        ],
                        staticClass: "brief-title-input",
                        attrs: { type: "text" },
                        domProps: { value: _vm.briefTitle },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.briefTitle = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "brief-modal-create-row" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.assignTarget,
                              expression: "assignTarget",
                            },
                          ],
                          staticClass: "brief-inline-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.assignTarget = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "internal_team" } }, [
                            _vm._v(
                              "\n              Internal team\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "option",
                            { attrs: { value: "specific_person" } },
                            [
                              _vm._v(
                                "\n              Specific person\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "agency_partner" } }, [
                            _vm._v(
                              "\n              Agency partner\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "optix_ai" } }, [
                            _vm._v(
                              "\n              Optix AI (auto-execute)\n            "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.assignEmail,
                            expression: "assignEmail",
                          },
                        ],
                        staticClass: "brief-inline-control",
                        attrs: {
                          type: "email",
                          placeholder: "person@brand.com",
                        },
                        domProps: { value: _vm.assignEmail },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.assignEmail = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.assignDueDate,
                            expression: "assignDueDate",
                          },
                        ],
                        staticClass: "brief-inline-control brief-inline-date",
                        attrs: { type: "date" },
                        domProps: { value: _vm.assignDueDate },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.assignDueDate = $event.target.value
                          },
                        },
                      }),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "brief-modal-content" }, [
                _c("div", { staticClass: "brief-modal-content-section" }, [
                  _c("label", { staticClass: "brief-modal-label" }, [
                    _vm._v("Overview"),
                  ]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.overviewText,
                        expression: "overviewText",
                      },
                    ],
                    attrs: { rows: "4" },
                    domProps: { value: _vm.overviewText },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.overviewText = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "brief-modal-content-section" }, [
                  _c("label", { staticClass: "brief-modal-label" }, [
                    _vm._v("Deliverables"),
                  ]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.deliverablesText,
                        expression: "deliverablesText",
                      },
                    ],
                    attrs: { rows: "10" },
                    domProps: { value: _vm.deliverablesText },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.deliverablesText = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "brief-modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "brief-modal-btn",
                    attrs: { type: "button" },
                    on: { click: _vm.submitAssignBrief },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "lucide lucide-user-plus h-4 w-4",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "16",
                          height: "16",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
                          },
                        }),
                        _vm._v(" "),
                        _c("circle", { attrs: { cx: "9", cy: "7", r: "4" } }),
                        _vm._v(" "),
                        _c("line", {
                          attrs: { x1: "19", x2: "19", y1: "8", y2: "14" },
                        }),
                        _vm._v(" "),
                        _c("line", {
                          attrs: { x1: "22", x2: "16", y1: "11", y2: "11" },
                        }),
                      ]
                    ),
                    _vm._v("\n        Create Brief...\n      "),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "brief-modal-close",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: { click: _vm.close },
                },
                [_c("i", { staticClass: "bi bi-x" })]
              ),
            ]
          ),
        ]
      )
    : _c("div")
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }